import InputMoney from "@/common/components/form/CurrencyInputFormik";
import InputFormik from "@/common/components/form/InputFormik";
import TextAreaFormik from "@/common/components/form/TextAreaFormik";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { formatDate, } from "@/common/helpers/date.helpers";
import { getPaymentBySubscriptionId } from "@/common/services/subscription.api";
import { PaymentInfo } from "@/types/payment.type";
import { IRenter } from "@/types/renter.type";
import { ISubscription } from "@/types/subscription.type";
import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";

type FormPropsEditSubscription = {
  subscription: ISubscription;
  renter: IRenter;
  onSubmit: (values) => Promise<{ ok: boolean, errors?: unknown[] }>;
}
export function FormEditSubscription({ subscription, onSubmit }: FormPropsEditSubscription) {

  const [payments, setPayments] = useState<PaymentInfo[]>([]);
  const formik = useFormik({
    initialValues: {
      ...subscription,
      nextDueDate: formatDate(subscription.nextDueDate).split('/').reverse().join('-'),
      endDate: formatDate(subscription.endDate).split('/').reverse().join('-'),
    },
    enableReinitialize: true,
    onSubmit: async (values) => {

      const result = await onSubmit(values)
      return result
    }
  })

  useEffect(() => {
    setPayments([]);
    async function paymentsBySubscriptionId(subscriptionId: string) {
      try {
        const result = await getPaymentBySubscriptionId(subscriptionId);
        if (result && result.ok) {
          setPayments(result.data);
        }
      } catch (err) {
        console.error("Erro ao buscar pagamentos da assinatura:", err);
      }
    }
    if (subscription._id) {
      paymentsBySubscriptionId(subscription.externalReferences.asaasSubscriptionId);
    }
  }, [subscription._id, subscription.externalReferences.asaasSubscriptionId]);

  return (
    <div className="space-y-6">
      <form onSubmit={formik.handleSubmit}>
        <FormikProvider value={formik}>
          <section id="subscription-edit-form" className="space-y-4">
            <InputMoney
              name="weeklyValue"
              label="Valor"
              placeholder="Digite o valor da assinatura"
            />
            <InputFormik
              name="nextDueDate"
              label="Próximo vencimento"
              type="date"
              placeholder="Selecione a data de vencimento"
              onChange={formik.handleChange}
              value={formik.values.nextDueDate}
            />
            <InputFormik
              name="endDate"
              label="Data de término"
              type="date"
              placeholder="Selecione a data de término"
              onChange={formik.handleChange}
              value={formik.values.endDate}
            />
            <TextAreaFormik
              name="planName"
              label="Descrição"
              placeholder="Digite a descrição da assinatura"
              onChange={formik.handleChange}
              value={formik.values.planName}
            />
            {payments.length > 0 && (
              <section id="subscription-payments" className="space-y-2">
                <h3 className="text-lg font-semibold">Pagamentos da Assinatura</h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-gray-300 px-4 py-2 text-left">Descrição</th>
                        <th className="border border-gray-300 px-4 py-2 text-left">Valor</th>
                        <th className="border border-gray-300 px-4 py-2 text-left">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments.map((payment) => (
                        <tr key={payment._id}>
                          <td className="border border-gray-300 px-4 py-2">{payment.description}</td>
                          <td className="border border-gray-300 px-4 py-2">
                            {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(payment.value)}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <span className={`px-2 py-1 rounded text-xs font-semibold ${payment.status === 'PENDING' ? 'bg-yellow-100 text-yellow-800' :
                              payment.status === 'RECEIVED' ? 'bg-green-100 text-green-800' :
                                payment.status === 'CONFIRMED' ? 'bg-blue-100 text-blue-800' :
                                  'bg-gray-100 text-gray-800'
                              }`}>
                              {payment.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
            )}
            <div className="flex justify-end pt-4">
              <ButtonWithLoader
                type="submit"
                isLoading={formik.isSubmitting}
              >
                Salvar Alterações
              </ButtonWithLoader>
            </div>
          </section>
        </FormikProvider>
      </form>

    </div>
  )
}